import { render, staticRenderFns } from "./PLPV2.vue?vue&type=template&id=0ccebe34&scoped=true&"
import script from "./PLPV2.vue?vue&type=script&lang=ts&"
export * from "./PLPV2.vue?vue&type=script&lang=ts&"
import style0 from "./PLPV2.vue?vue&type=style&index=0&id=0ccebe34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccebe34",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAdSlot: require('/var/www/packages/theme/components/atoms/AdSlot.vue').default,AtomsProductBreadcrumbs: require('/var/www/packages/theme/components/atoms/ProductBreadcrumbs.vue').default,AtomsShowMoreText: require('/var/www/packages/theme/components/atoms/ShowMoreText.vue').default,AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,MoleculesHeaderBannerCard: require('/var/www/packages/theme/components/molecules/HeaderBannerCard.vue').default,TemplatesProductListing: require('/var/www/packages/theme/components/templates/ProductListing.vue').default})
